export default class Device {

    constructor(
        id,
        hardwareId,
        simNumber,
        enabled,
        serialNumber,
        firmwareVersion,
        dateToCapture,
        channelFlag,
        customerSim,
        automaticVideoDownload,
        firstReported,
        deviceModelId,
        deviceProtocolId,
        organizationId,
        fleetId,
        vehicleId,
    ) {
        this.id = id
        this.hardwareId = hardwareId
        this.simNumber = simNumber
        this.enabled = enabled
        this.serialNumber = serialNumber
        this.firmwareVersion = firmwareVersion
        this.dateToCapture = dateToCapture
        this.channelFlag = channelFlag
        this.customerSim = customerSim
        this.automaticVideoDownload = automaticVideoDownload
        this.firstReported = firstReported
        this.deviceModelId = deviceModelId
        this.deviceProtocolId = deviceProtocolId
        this.organizationId = organizationId
        this.fleetId = fleetId
        this.vehicleId = vehicleId
    }


}
